import { Icon } from '@podiumhq/design-system';

const GoogleStars = () => (
  <>
    <Icon type="StarSolid" boxSize="20px" color="gold" />
    <Icon type="StarSolid" boxSize="20px" color="gold" />
    <Icon type="StarSolid" boxSize="20px" color="gold" />
    <Icon type="StarSolid" boxSize="20px" color="gold" />
    <Icon type="StarSolid" boxSize="20px" color="gold" />
  </>
);

export default GoogleStars;
